import React from 'react';
import {OrderProductOperationBodyProps} from '@views/orders/fields/products/extra_row/operations/.types';
import NowLoadingMessage from '@src/components/NowLoadingMessage/NowLoadingMessage';

const Body = React.lazy(() => import('@views/orders/fields/products/extra_row/operations/Body'));

export default function LazyBody(props: OrderProductOperationBodyProps) {
    return <React.Suspense fallback={<NowLoadingMessage/>}>
        <Body {...props}/>
    </React.Suspense>;
}
